import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Kiacarensonrentinmumbai() {



  const cardData = {
    keyword: " Kia Carens On Rent in Mumbai",


"headingDescription": "Royal Route Cab offers premium Kia Carens on rent in Mumbai, providing spacious, comfortable, and reliable travel solutions for families, corporate groups, airport transfers, weddings, and outstation trips. Kia Carens is a modern 6/7-seater MPV known for its stylish design, superior comfort, and advanced features, making it an excellent choice for group travel in Mumbai. Whether you need a local ride, Mumbai darshan, airport pickup, or long-distance journey, our well-maintained Kia Carens ensures a smooth and stress-free experience. With professional drivers, clean interiors, and flexible booking options, we deliver a premium travel experience with transparent pricing and no hidden charges. Our services are available 24/7 with instant booking support.",

"topPlaces": [
  {
    "title": "Airport Transfers (Mumbai Airport)",
    "description": "Kia Carens is one of the best options for Mumbai Airport transfers, especially for families and small groups traveling with luggage. Its spacious seating and large boot space make it ideal for comfortable airport pickups and drops. Professional drivers track flight timings and ensure punctual service, making travel hassle-free. The vehicle’s smooth ride quality helps passengers relax after long flights, making it a preferred choice for domestic and international airport transfers."
  },
  {
    "title": "Mumbai Darshan (City Tour)",
    "description": "Kia Carens is perfect for full-day Mumbai darshan tours where groups can explore multiple attractions comfortably. From South Mumbai landmarks to beaches and shopping areas, the vehicle offers ample space and air-conditioned comfort for long hours of sightseeing. Its premium interiors and smooth suspension make city travel enjoyable even in heavy traffic conditions."
  },
  {
    "title": "Outstation Trips from Mumbai",
    "description": "Kia Carens is widely preferred for outstation travel to destinations like Lonavala, Shirdi, Pune, Nashik, Mahabaleshwar, and Gujarat. Its strong highway performance, stable driving experience, and comfortable seating make long-distance journeys smooth and relaxing. Rental packages for outstation trips typically include daily km limits and driver charges, making it a cost-effective option for group travel. :contentReference[oaicite:0]{index=0}"
  },
  {
    "title": "Corporate Travel",
    "description": "For business travel, Kia Carens offers a premium and professional experience suitable for client meetings, airport transfers, and employee transportation. Its stylish interiors, comfortable seating, and quiet cabin create a perfect environment for corporate use. Many companies prefer it for its balance of luxury and affordability."
  },
  {
    "title": "Family Trips & Group Travel",
    "description": "Kia Carens is designed for family comfort with flexible 6 and 7-seater configurations, making it ideal for group outings. It provides ample legroom, rear AC vents, and comfortable seating for all passengers, ensuring a pleasant journey for both short and long trips."
  },
  {
    "title": "Wedding & Event Transport",
    "description": "Kia Carens is a popular choice for wedding guest transportation and family functions due to its spacious design and elegant appearance. It helps manage group travel efficiently, reducing the need for multiple vehicles and ensuring coordinated movement for events."
  },
  {
    "title": "Self Drive & Chauffeur Options",
    "description": "Kia Carens is available in both self-drive and chauffeur-driven options in Mumbai. Self-drive rentals offer flexibility and privacy, while chauffeur-driven services provide convenience and stress-free travel with experienced drivers. :contentReference[oaicite:1]{index=1}"
  },
  {
    "title": "Weekend Getaways",
    "description": "Popular weekend destinations like Alibaug, Matheran, Igatpuri, and Lavasa are best explored with a Kia Carens rental. The vehicle’s comfort and space allow travelers to carry luggage easily while enjoying scenic drives without compromising on convenience."
  },
  {
    "title": "Long Distance Highway Travel",
    "description": "Kia Carens performs exceptionally well on highways with stable handling and comfortable seating for long hours. It is equipped with safety features like airbags and stability control, making it a reliable option for interstate travel. :contentReference[oaicite:2]{index=2}"
  },
  {
    "title": "Pilgrimage Tours",
    "description": "Kia Carens is ideal for religious trips such as Shirdi, Trimbakeshwar, Bhimashankar, and Shani Shingnapur. Its comfortable seating and smooth ride quality ensure a peaceful and convenient journey for devotees traveling in groups."
  }
],






services: [
  {
    name: "Kia Carens on Rent Mumbai",
    description: "Kia Carens on rent in Mumbai offers a modern, spacious, and comfortable travel option for families and group travelers. Known for its premium interiors and smooth ride quality, it is ideal for city travel, airport transfers, and outstation trips. Professional drivers ensure safety. It guarantees a relaxing travel experience."
  },
  {
    name: "Kia Carens Cab Service Mumbai",
    description: "Kia Carens cab service Mumbai provides reliable and premium transportation with well-maintained vehicles and trained drivers. This service is perfect for family travel, corporate trips, and group outings. Spacious seating enhances comfort. It ensures a smooth journey."
  },
  {
    name: "Carens Taxi Mumbai",
    description: "Carens taxi Mumbai offers comfortable and stylish rides for local and outstation travel. This service is ideal for families and small groups looking for extra space. Clean vehicles and professional drivers ensure safety. It guarantees a pleasant ride."
  },
  {
    name: "Kia Carens Rental Mumbai",
    description: "Kia Carens rental Mumbai provides flexible rental options for personal and business travel. Customers can choose hourly, daily, or outstation packages. The vehicle’s comfort and modern features enhance travel experience. It ensures convenient and reliable transport."
  },
  {
    name: "Carens Car Hire Mumbai",
    description: "Carens car hire Mumbai offers premium travel with flexible booking options. Ideal for city rides, long-distance travel, and airport transfers. Spacious interiors and smooth driving experience ensure comfort. It guarantees a hassle-free journey."
  },
  {
    name: "Carens Cab Booking Mumbai",
    description: "Carens cab booking Mumbai allows customers to reserve their ride easily with flexible options. Travelers can choose pickup location, timing, and trip type. Instant confirmation ensures availability. It simplifies travel planning."
  },
  {
    name: "Carens Taxi Booking Online Mumbai",
    description: "Carens taxi booking online Mumbai provides a quick and convenient way to book your ride. Customers can compare vehicles and pricing easily. Secure payment and instant confirmation enhance convenience. It ensures hassle-free booking."
  },
  {
    name: "Carens Rental Price Mumbai",
    description: "Carens rental price Mumbai varies based on distance, duration, and trip type. Transparent pricing ensures no hidden charges. Customers can choose budget or premium packages. It helps in planning travel costs efficiently."
  },
  {
    name: "Carens Taxi Fare Mumbai",
    description: "Carens taxi fare Mumbai is designed to be competitive and affordable. Fare depends on route, vehicle usage, and travel duration. Customers receive clear pricing details before booking. It ensures cost-effective travel."
  },
  {
    name: "Carens One Way Cab Mumbai",
    description: "Carens one way cab Mumbai offers cost-effective travel without return charges. This service is ideal for single-side journeys and airport transfers. Flexible pickup options enhance convenience. It ensures smooth and economical travel."
  },
  {
    name: "Carens Round Trip Cab Mumbai",
    description: "Carens round trip cab Mumbai provides complete travel solutions including return journeys. This service is ideal for outstation trips, vacations, and business travel. Flexible schedules enhance convenience. It ensures a hassle-free experience."
  },
  {
    name: "Cheap Carens Rental Mumbai",
    description: "Cheap Carens rental Mumbai offers budget-friendly travel options without compromising comfort and safety. Ideal for families and groups looking for affordable premium travel. Transparent pricing ensures no hidden charges. It ensures economical travel."
  },
  {
    name: "Best Carens Cab Service Mumbai",
    description: "Best Carens cab service Mumbai ensures top-quality vehicles, professional drivers, and excellent customer support. This service focuses on comfort, safety, and punctuality. It guarantees a premium and reliable travel experience."
  },
  {
    name: "Carens Airport Cab Mumbai",
    description: "Carens airport cab Mumbai provides convenient pickup and drop services to and from the airport. Spacious interiors make it ideal for luggage-heavy travel. Timely service ensures stress-free transfers. It guarantees a comfortable airport journey."
  },
  {
    name: "Carens Outstation Cab Mumbai",
    description: "Carens outstation cab Mumbai is perfect for long-distance travel and intercity trips. Spacious seating and smooth performance make it ideal for highways. Professional drivers ensure safety. It ensures a comfortable outstation experience."
  }
],

tableData: [
  ["Kia Carens on Rent Mumbai", "Kia Carens Cab Service Mumbai"],
  ["Carens Taxi Mumbai", "Kia Carens Rental Mumbai"],
  ["Carens Car Hire Mumbai", "Carens Cab Booking Mumbai"],
  ["Carens Taxi Booking Online Mumbai", "Carens Rental Price Mumbai"],
  ["Carens Taxi Fare Mumbai", "Carens One Way Cab Mumbai"],
  ["Carens Round Trip Cab Mumbai", "Cheap Carens Rental Mumbai"],
  ["Best Carens Cab Service Mumbai", "Carens Airport Cab Mumbai"],
  ["Carens Outstation Cab Mumbai", ""]
],


whychoose: [
  {
    WhyChooseheading: "Comfortable Kia Carens on Rent in Mumbai",
    WhyChoosedescription: "Royal Route Cabs offers premium Kia Carens rental in Mumbai, ideal for family travel, airport transfers, and outstation journeys with maximum comfort."
  },
  {
    WhyChooseheading: "Spacious 6–7 Seater MPV",
    WhyChoosedescription: "Kia Carens provides comfortable seating for 6-7 passengers with ample legroom and luggage space, making it perfect for group travel." 
  },
  {
    WhyChooseheading: "Smooth Ride for City & Highway",
    WhyChoosedescription: "Kia Carens is known for its smooth driving experience, making it suitable for both Mumbai city rides and long-distance travel." 
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear pricing with all fare details upfront including tolls and driver allowance with no hidden costs." 
  },
  {
    WhyChooseheading: "24/7 Rental Availability",
    WhyChoosedescription: "Our Kia Carens on rent service in Mumbai is available round the clock for flexible travel anytime." 
  },
  {
    WhyChooseheading: "Clean & Well-Maintained Vehicles",
    WhyChoosedescription: "All Kia Carens vehicles are regularly serviced, sanitized, and maintained for a safe and comfortable journey." 
  },
  {
    WhyChooseheading: "Flexible Rental Packages",
    WhyChoosedescription: "Choose from hourly rental, full-day packages, one-way, or round-trip bookings as per your travel plan." 
  },
  {
    WhyChooseheading: "Trusted MPV Rental Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by customers for reliable Kia Carens rental in Mumbai with professional drivers and punctual service." 
  }
]

};

const faqData = [
  { question: "Do you provide Kia Carens on rent in Mumbai?", answer: "Yes, Royal Route Cabs offers Kia Carens rental services in Mumbai for local and outstation travel." },
  { question: "What is the price of Kia Carens on rent in Mumbai?", answer: "Kia Carens rental in Mumbai typically starts from ₹3800 to ₹5500 per day or around ₹17 per km depending on package." },
  { question: "How many passengers can travel in Kia Carens?", answer: "Kia Carens can comfortably seat 6 to 7 passengers." },
  { question: "Is Kia Carens suitable for long-distance travel?", answer: "Yes, Kia Carens is ideal for both city and long-distance travel due to its comfort and space." },
  { question: "Is rental available 24 hours?", answer: "Yes, our Kia Carens rental service operates 24/7." },
  { question: "Do you provide driver with Kia Carens rental?", answer: "Yes, all rentals include professional drivers." },
  { question: "Do you provide airport pickup with Kia Carens?", answer: "Yes, we offer Mumbai airport pickup and drop services with Kia Carens." },
  { question: "Can I book for one-way trips?", answer: "Yes, we provide both one-way and round-trip booking options." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended for better availability." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Nitin Mehta",
    feedback: "Kia Carens on rent in Mumbai with Royal Route Cabs was very comfortable. The vehicle was spacious, modern, and ideal for our family trip.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Ritu Shah",
    feedback: "Excellent experience renting Kia Carens in Mumbai. The cab was clean, well-maintained, and the ride quality made our journey very relaxing.",
    rating: 5
  }
];








  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Kia Carens on Rent in Mumbai",
  "image": "https://www.royalroutecabs.com/assets/images/kia-carens-on-rent-mumbai.jpg", // replace if needed
  "description": "Book Kia Carens on rent in Mumbai with Royal Route Cabs for comfortable and spacious 6–7 seater travel. Ideal for family trips, airport transfers, and outstation journeys. Available for one-way and round-trip taxi service with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "12/km", // indicative rate (adjust if needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/kia-carens-on-rent-mumbai"
  }
};



  return (
    <div>

<Helmet>
  <title>Kia Carens on Rent in Mumbai | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Kia Carens on rent in Mumbai with Royal Route Cabs. Comfortable 6–7 seater cab for family trips, airport transfers, and outstation travel. 24x7 reliable taxi service."
  />

  <meta
    name="keywords"
    content="kia carens on rent mumbai, kia carens cab service mumbai, carens taxi mumbai, kia carens rental mumbai, carens car hire mumbai, carens cab booking mumbai, carens taxi booking online mumbai, carens rental price mumbai, carens taxi fare mumbai, carens one way cab mumbai, carens round trip cab mumbai, cheap carens rental mumbai, best carens cab service mumbai, carens airport cab mumbai, carens outstation cab mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/71.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Kiacarensonrentinmumbai;